import { axiosInstance as request } from '@/api/rest.service'

export const getChartData = (name, id) => request.get(`/charts/${name}/subscriptions/${id}`)
